import { Telefone } from '../telefone.model';

export class EditarTelefoneDTO {
  clienteId: number;
  telefone: Telefone;
}
